import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import Logo from './KalibrrLogo';
import { SITE_CONFIG } from '../utils/site';
import { BlogType } from '../models/blog';

const HeaderWrapper = styled.div`
  width: 100%;
  max-height: 80px;
  padding: 0 1rem;
  border-bottom: 5px solid var(--primary-color);
  display: flex;
  align-items: center;
`;

const Description = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: flex;
    margin-left: 4rem;
  }
`;

const NavMenu = styled.ul`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    list-style-type: none;
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 0;
  }

  .nav-menu-item:not(:first-child) {
    margin-left: 2rem;
  }
`;

interface HeaderProps {
  style?: React.CSSProperties;
}

const Header: React.FC<HeaderProps> = ({ style }) => {
  const blogType = process.env.GATSBY_BLOG_TYPE as BlogType;
  const siteConfig = SITE_CONFIG[blogType];

  return (
    <HeaderWrapper style={style}>
      <Logo title={siteConfig.title} />
      <Description className='text-muted'>{siteConfig.description}</Description>
      <NavMenu>
        {siteConfig.menuItems.map((item, index) =>
          item.path.startsWith('/') ? (
            <Link className='nav-menu-item' key={item.label} to={item.path}>
              <li>{item.label}</li>
            </Link>
          ) : (
            <a className='nav-menu-item' key={item.label} href={item.path}>
              <li>{item.label}</li>
            </a>
          )
        )}
      </NavMenu>
    </HeaderWrapper>
  );
};

export default Header;
